module.exports = __webpack_public_path__ + "images/kurtosis-08-desktop.png";